import React from 'react';
import { SectionHeading } from './SectionHeading';
import { PAIN_POINTS } from '../data/content';
export function PainSection() {
  return <section className="border-y border-ink-700/60 bg-ink-900 py-10 sm:py-12" style={{
    paddingTop: "8px",
    paddingBottom: "53px"
  }} data-id="element-129" data-mp="38x5ccaw9fiwa">
      <div className="mx-auto max-w-content px-5" style={{
      paddingTop: "37px"
    }} data-id="element-130" data-mp="2yzquc6uoum1v">
        <SectionHeading eyebrow="IF YOU END THE DAY LIKE THIS" title="This sounds" highlight="familiar" subtitle="Tension doesn’t leave on its own. And massaging where it hurts doesn’t fix it either. The spot that screams is almost never the origin. That’s why relief lasts 48 hours and the pain returns to the exact same place every day." data-id="element-131" data-mp="2z1ljxygwn2ca" />

        <ul className="mt-6 grid gap-3 md:grid-cols-2 lg:grid-cols-3" data-id="element-132" data-mp="2g8hihqxg3l74">
          {PAIN_POINTS.map(point => <li key={point.title} className="flex h-full flex-col rounded-2xl border border-ink-700 bg-ink-850 p-5" style={{
          paddingTop: "0px"
        }} data-id="element-133" data-mp="22985t18g797w">
              <span className="text-xl" aria-hidden="true" data-id="element-134" data-mp="3rn0tnjs54s6n">
                {point.emoji}
              </span>
              <h3 className="mt-2 text-sm font-bold leading-snug text-white sm:text-base" data-id="element-135" data-mp="3nlpc81jf7d9j">
                {point.title}
              </h3>
              <p className="mt-1.5 text-sm leading-snug text-white/60" data-id="element-136" data-mp="5ehr50ia6bsh">{point.body}</p>
            </li>)}
        </ul>

        <p className="mx-auto mt-7 max-w-2xl text-center text-lg font-extrabold leading-snug text-lime-400 sm:text-xl" data-id="element-137" data-mp="hixej2j46ut">
          What if today was the last day you treated the echo instead of the source?
        </p>
      </div>
    </section>;
}